import { USER_LANGUAGES } from '../assets/AppConstants';

export const getDefaultLanguage = () => {
  const browserLang = navigator.language.substring(0, 2);
  const language = USER_LANGUAGES.find((el) => (
    el.name.toLocaleLowerCase() === browserLang.toLocaleLowerCase()
  ));

  return language || USER_LANGUAGES[0];
};
